import { Box, Grid, Typography } from '@mui/material';
import * as setup from 'setup';
import Image from '../Image/Image';
import { FoodTypePickerOption } from './FoodTypePicker.styles';

export default function FoodTypePicker({ onPick }: FoodTypePickerProps) {

    return (
        <Box
            sx={{
                marginX: 'auto',
                maxWidth: 800
            }}>
            <Typography
                sx={{
                    marginBottom: 3,
                    textAlign: 'center'
                }}>
                Choose food type:
            </Typography>
            <Box>
                <Grid container spacing={3}>
                    {setup.game.foodTypes.map(type => (
                        <Grid
                            key={type}
                            size={{ xs: 4, lg: 2 }}
                            sx={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}>
                            <FoodTypePickerOption onClick={() => onPick(type)}>
                                <Image alt={type} height={82} src={`/assets/images/${type}.svg`} />
                                {type}
                            </FoodTypePickerOption>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );

}